$(document).ready(function () {
    $('[data-sales-useperson]').click(function () {
        const data = JSON.parse(this.dataset.salesman);

        $('[data-sales-person]').each(function () {
            const type = this.dataset.salesPerson;

            switch (type) {
                case 'img':
                    $(this).attr('src', data[type]);
                    break;
                case 'mail':
                    $(this).attr('data-clipboard', data[type]);
                    $(this).html(data[type] + '<span class="my-icon my-bw-copy"></span>');
                    break;
                case 'linkedin':
                    $(this).attr('href', data[type]);
                    break;
                case 'name':
                    $(this).text(data[type]);
                    break;
                case 'role':
                    $(this).text(data[type]);
                    break;
                case 'region':
                    $(this).text(data[type]);
                    break;
                case 'countries':
                    $(this).text(data['countries'].join(' / '));
                    break;
            }
        })
        $('#salesPersonEmail').val(data['mail']);
        $('[data-sales-modalcard]').removeClass('d-none');
    });

    $('#salesmanModal').on('hide.bs.modal', function () {
        $('[data-sales-modalcard]').addClass('d-none');
        $('.grecaptcha-badge').css('visibility', 'hidden');
    })

    $('#filterSales input').click(function () {
        showSalesman(this.value);

        function showSalesman(val) {
            if (val === 'all') {
                $('#salesmanList [data-filter]').removeClass('d-none');
            } else {
                const list = val.split(';');
                $('#salesmanList [data-filter]').each(function () {
                    let noCountry = true;
                    const salesmanCountries = $(this).data('filter');

                    for (const filterCountry of list) {
                        if (salesmanCountries.includes(filterCountry)) noCountry = false;
                    }
                    $(this).toggleClass('d-none', noCountry)
                })
            }
        }
    })

    const form = document.querySelector('#salesmanForm');
    form.addEventListener('submit', function () {
        const checkbox = document.querySelector('input[name="sendnewsletter"]');

        if (checkbox.checked) {
            const formData = new FormData(form);
            fetch('/static/mail/hubspot_subscribe.php', {
                method: 'POST',
                body: formData
            })
        }
    });
});

$(window).on('resize load', function() {
    $('.blog__latest [data-view-card]').attr('data-view-card', window.mobileTrigger ? 'block' : 'wide');
});

$(document).ready(function () {
    const submitBtn = document.querySelector('#regionalSubmit');
    const salesForm = document.querySelector('#salesmanForm');
    const salesFooter = document.querySelector('.salesman-modal .modal-footer');
    if (!submitBtn || !salesForm || !salesFooter) return;

    salesFooter.addEventListener('click', function (e) {
        if (!submitBtn.disabled) return;
        var rect = submitBtn.getBoundingClientRect();
        if (e.clientX >= rect.left && e.clientX <= rect.right &&
            e.clientY >= rect.top && e.clientY <= rect.bottom) {
            showSalesFormErrors(salesForm);
        }
    });

    salesForm.addEventListener('input', function (e) {
        var group = e.target.closest('.form__group');
        if (group && group.classList.contains('form__error') && e.target.value.trim()) {
            inputMessage(e.target, 'remove');
        }
    });

    salesForm.addEventListener('click', function (e) {
        if (e.target.matches('[data-dropdown-select-input]')) {
            inputMessage(e.target, 'remove');
        }
    });
});

function showSalesFormErrors(form) {
    var checkedRadios = {};
    form.querySelectorAll('[required]').forEach(function (field) {
        if (field.type === 'radio') {
            if (!(field.name in checkedRadios)) {
                checkedRadios[field.name] = !!form.querySelector('input[type="radio"][name="' + field.name + '"]:checked');
            }
        } else {
            if (!field.value.trim()) {
                inputMessage(field, 'error', field.dataset.err || '');
            } else {
                inputMessage(field, 'remove');
            }
        }
    });
    Object.keys(checkedRadios).forEach(function (name) {
        if (!checkedRadios[name]) {
            var bwSelect = form.querySelector('.bw-dropdown:has(input[name="' + name + '"]) .bw-select');
            if (bwSelect) inputMessage(bwSelect, 'error', bwSelect.dataset.err || '');
        }
    });
}
